<template>
<!-- FINAL ICARE -->
<div class="wrapper">
  <div>
    <CButton   color="info" @click="openModal"><b>Add New iCare Youth</b></CButton>
      <CRow class="mt-3">
        <div>       
        </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        />
                    </div>
                </div>
            </div>
        </div>  
      </CCol>
    </CRow>
    <icaremodal></icaremodal>
    <alertmodal></alertmodal>
</div>
</div>
</template>

<script>
import Datatable from '@/components/datatables.vue'
import axios from 'axios';

import icare from '@/services/icareyouth';
import icaremodal from './icare_modal';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'IcareTables',
  components: { Datatable, icaremodal, alertmodal },
   data () {
    return {
      form:{
        name:'',
        city:'',
        state:'',
        country:'',
        zone:'',
        leader:'',
      },
      largeModal: false,
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'city', sortable: false},
          {key: 'state', sortable: false},
          {key: 'country', sortable: false},
          {key: 'zone', sortable: false},
          {key: 'leader', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
   },
   mounted (){
     this.loadData()
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
    openModal: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
      var params = {title: 'Add New iCare Youth', mode:'create'}
      EventBus.$emit('OPEN_MODAL_ICARE', params)
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
  
    openShow: function(id){
      let routeData = this.$router.resolve({path: '/icare-youth/icare_detail_youth',query: {Pud:id} }) 
      window.open(routeData.href, '_blank');
      //SET END
    },

    openModalEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit iCare Youth', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_ICARE', params)
         //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      icare.getIcareDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.deactivate(val)       
    },

  

  }
}
</script>
